interface IProps {
  duplexModes: { value: boolean; label: string }[];
  selectedDuplexMode: boolean;
  onDuplexModeChanged: (duplexMode: boolean) => void;
}

function DuplexModeSelector({
  duplexModes,
  selectedDuplexMode,
  onDuplexModeChanged,
}: IProps) {
  function handleSelectChanged(e: React.ChangeEvent<HTMLSelectElement>) {
    switch (e.target.value) {
      case "true":
        onDuplexModeChanged(true);
        break;
      case "false":
      default:
        onDuplexModeChanged(false);
        break;
    }
  }

  return (
    <tr>
      <th className="label">
        <label htmlFor="cq-pod-paper-size">
          Duplex Mode <span color="red">*</span>
        </label>
        <span
          className="woo-selected-variation-item-name"
          data-default=""
        ></span>
      </th>
      <td className="value">
        <select
          id="cq-pod-paper-size"
          className=""
          name="cq-pod-paper-size"
          onChange={handleSelectChanged}
          value={selectedDuplexMode.toString()}
        >
          <option value="">Choose an option</option>
          {duplexModes.map((duplexMode) => (
            <option
              key={duplexMode.value.toString()}
              value={duplexMode.value.toString()}
              className="attached enabled"
            >
              {duplexMode.label}
            </option>
          ))}
        </select>
      </td>
    </tr>
  );
}

export default DuplexModeSelector;
